import { Heading } from '@lili/lili-frontend-common';
import React from 'react';
import { PasswordStrength } from '../../services/passwordStrengthIndicator';

export interface PasswordStrengthTexts {
  tooWeak: string;
  weak: string;
  medium: string;
  strong: string;
}

interface ISingleElementProps {
  indicatorColor: string;
  disabledColor: string;
  showIndicator: boolean;
}

export const SingleLevelIndicator = ({ indicatorColor, showIndicator, disabledColor }: ISingleElementProps) => (
  <div style={{ backgroundColor: disabledColor }} className='h-[5px] basis-1/3 rounded-md'>
    <div
      style={{
        backgroundColor: indicatorColor,
        opacity: showIndicator ? 1 : 0,
      }}
      className='h-[5px] w-full rounded-md  bg-action05'
    />
  </div>
);

interface IProps {
  strength: PasswordStrength;
  containerClassName?: string;
  passwordStrengthTexts: PasswordStrengthTexts;
}

export const PasswordStrengthIndicator = ({ strength, passwordStrengthTexts, containerClassName }: IProps) => {
  const disabledColor = '#D9D9D9';

  const indicatorColor = () => {
    switch (strength) {
      case PasswordStrength.TooWeak:
        return '#E74343';
      case PasswordStrength.Weak:
        return '#FFA500';
      case PasswordStrength.Medium:
        return '#FDD835';
      case PasswordStrength.Strong:
        return '#44CA38';
      default:
        return disabledColor;
    }
  };

  const indicatorTitle = () => {
    switch (strength) {
      case PasswordStrength.TooWeak:
        return passwordStrengthTexts.tooWeak;
      case PasswordStrength.Weak:
        return passwordStrengthTexts.weak;
      case PasswordStrength.Medium:
        return passwordStrengthTexts.medium;
      case PasswordStrength.Strong:
        return passwordStrengthTexts.strong;
      default:
        return '';
    }
  };

  return (
    <div className={containerClassName}>
      <div className='flex flex-row rounded-md gap-1 mb-[4px]'>
        <SingleLevelIndicator
          indicatorColor={indicatorColor()}
          disabledColor={disabledColor}
          showIndicator={strength >= PasswordStrength.TooWeak}
        />
        <SingleLevelIndicator
          indicatorColor={indicatorColor()}
          disabledColor={disabledColor}
          showIndicator={strength >= PasswordStrength.Weak}
        />
        <SingleLevelIndicator
          indicatorColor={indicatorColor()}
          disabledColor={disabledColor}
          showIndicator={strength >= PasswordStrength.Medium}
        />
        <SingleLevelIndicator
          indicatorColor={indicatorColor()}
          disabledColor={disabledColor}
          showIndicator={strength >= PasswordStrength.Strong}
        />
      </div>
      <Heading.H10 className='text-text-main-tertiary'>{indicatorTitle()}</Heading.H10>
    </div>
  );
};
